import { render, staticRenderFns } from "./recipients-table-review.vue?vue&type=template&id=4ead7605&scoped=true&"
import script from "./recipients-table-review.vue?vue&type=script&lang=js&"
export * from "./recipients-table-review.vue?vue&type=script&lang=js&"
import style0 from "./recipients-table-review.vue?vue&type=style&index=0&id=4ead7605&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead7605",
  null
  
)

export default component.exports